import useFlag from 'hooks/useFlag'
import {
  formatPermissionReason,
  usePermissionLabel,
} from 'hooks/useRbacNavCheck'
import { useAbility } from 'utilities/ability'

export type UseGiftCardsAccess = {
  show: boolean
  disabled: boolean
  disabledReason: string | undefined
  canAccess: boolean
  // Publish is gated separately from view access; mirrors the server's
  // `rbac_authorize!('manage', 'digital_experiences')` on the PATCH.
  manageDisabled: boolean
  manageDisabledReason: string | undefined
}

// No legacy role grants DigitalExperiences (admins only via `manage all`), so
// while `role-based-access-control` is off this stays permissive rather than
// falling back to a `manage`-only default that would lock out every non-admin
// who can reach the page today.
export function useGiftCardsAccess(): UseGiftCardsAccess {
  const show = useFlag('gift-cards-mx', false)
  const rbacEnabled = useFlag('role-based-access-control', false)
  const ability = useAbility()
  const label = usePermissionLabel('DigitalExperiences')

  const disabled = rbacEnabled && ability.cannot('access', 'DigitalExperiences')
  const manageDisabled =
    rbacEnabled && ability.cannot('manage', 'DigitalExperiences')

  return {
    show,
    disabled,
    disabledReason: formatPermissionReason(label, disabled),
    canAccess: !disabled,
    manageDisabled,
    manageDisabledReason: formatPermissionReason(label, manageDisabled),
  }
}

export default useGiftCardsAccess
